export const moon = {
  name: "moon" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M9.493 8.687c0-1.323.445-2.535 1.187-3.507A6.947 6.947 0 0 0 12 18.946a6.946 6.946 0 0 0 6.818-5.627 5.746 5.746 0 0 1-3.506 1.188 5.82 5.82 0 0 1-5.82-5.82Zm1.8 0c0 2.22 1.8 4.02 4.02 4.02a4.007 4.007 0 0 0 3.617-2.303l.074-.127a.9.9 0 0 1 1.629.376c.065.425.113.875.113 1.347A8.746 8.746 0 1 1 12 3.254c.472 0 .922.047 1.347.113a.9.9 0 0 1 .25 1.702 4.008 4.008 0 0 0-2.304 3.618Z"/></svg>`,
  keywords: ["moon"],
  category: "other" as const,
};
